"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.map = void 0;

var _reducer = require("../../../client/lib/reducer");

var _lodash = _interopRequireDefault(require("lodash.assign"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  open: false,
  zoom: 8,
  coordinates: {
    lat: 46.909957,
    lon: 8.498662
  },
  activeFarmIdOnMap: 0
};
var map = (0, _reducer.createReducer)(initialState, {
  'map-set-open': function mapSetOpen(state) {
    return (0, _lodash.default)({}, state, {
      open: true
    });
  },
  'map-set-closed': function mapSetClosed() {
    return (0, _lodash.default)({}, initialState);
  },
  'map-update-zoom': function mapUpdateZoom(state, action) {
    return (0, _lodash.default)({}, state, {
      zoom: action.zoom
    });
  },
  'map-update-coordinates': function mapUpdateCoordinates(state, action) {
    return (0, _lodash.default)({}, state, {
      coordinates: {
        lat: action.lat,
        lon: action.lon
      }
    });
  },
  'map-set-active-farm-id': function mapSetActiveFarmId(state, action) {
    return (0, _lodash.default)({}, state, {
      activeFarmIdOnMap: action.farmId
    });
  }
});
exports.map = map;


//////////////////
// WEBPACK FOOTER
// ./client/components/hofsearch-map/reducer.js
// module id = 600
// module chunks = 0